export default __webpack_public_path__ + "77ef23c157e4da8d18ca5d143dcb1b75.svg";